export const getOperationsHeaderTab = (searchParams) =>
  searchParams.get('tab') === 'progression' ? 'progression' : 'dashboard';

export const buildOperationsHeaderTabParams = (searchParams, tab) => {
  const next = new URLSearchParams(searchParams);

  if (tab === 'progression') {
    next.set('tab', 'progression');
  } else {
    next.delete('tab');
  }

  return next;
};
